/* Shared deterministic algorithm. Keep in sync with backend services/loanCalculation.js. */
function calculateLoanConditions(conditions) {
  const { principal, annualRate, months, extraPayments = [], currency = 'USD' } = conditions;
  if (!Number.isFinite(principal) || principal <= 0 || principal > 1e12 ||
      !Number.isFinite(annualRate) || annualRate < 0 || annualRate > 1000 ||
      !Number.isInteger(months) || months < 1 || months > 600 ||
      !Array.isArray(extraPayments) || extraPayments.length > months ||
      extraPayments.some(value => !Number.isFinite(value) || value < 0 || value > 1e12) || !/^[A-Z]{3}$/.test(currency)) {
    throw new Error('Ingresa monto y tasa válidos, de 1 a 600 meses y amortizaciones no negativas.');
  }
  const rate = annualRate / 1200;
  const monthlyPayment = rate === 0 ? principal / months : principal * rate / -Math.expm1(-months * Math.log1p(rate));
  let balance = principal;
  let totalInterest = 0;
  let totalExtra = 0;
  const paymentPlan = [];
  for (let month = 1; month <= months && balance > 0; month++) {
    const initialBalance = balance;
    const interest = initialBalance * rate;
    const principalPayment = month === months ? initialBalance : Math.min(initialBalance, Math.max(0, monthlyPayment - interest));
    const extraAmortization = Math.min(extraPayments[month - 1] || 0, initialBalance - principalPayment);
    balance = Math.max(0, initialBalance - principalPayment - extraAmortization);
    if (balance < principal * Number.EPSILON * 8) balance = 0;
    totalInterest += interest;
    totalExtra += extraAmortization;
    paymentPlan.push({ month, initialBalance, interest, principalPayment, extraAmortization, totalPayment: principalPayment + extraAmortization + interest, finalBalance: balance });
  }
  return { summary: { monthlyPayment, totalInterest, totalPaid: principal + totalInterest, totalExtra, monthsPaid: paymentPlan.length, finalBalance: balance, currency }, paymentPlan };
}
module.exports = { calculateLoanConditions };